export const EARNING_RULE_TYPES = {
  ORDER: '0',
  AMOUNT: '1',
  REFERRAL: '2',
  SIGN_UP: '3',
  ITEM_PURCHASED: '4',
};

export const PROMOTION_RULE_TYPES = {
  ORDER: '0',
  AMOUNT: '1',
  REFERRAL: '2',
  SIGN_UP: '3',
  ITEM_PURCHASED: '4',
};

export const REDEMPTION_RULE_TYPES = {
  ORDER: '0',
  AMOUNT: '1',
  REFERRAL: '2',
  SIGN_UP: '3',
  ITEM_PURCHASED: '4',
};
